import { TestRequest } from './service-models/test/TestRequest';
import { TestResult } from './service-models/test/TestResult';
import { WprBaseViewCore } from '../wpr-framework/view/WprBaseViewCore';
import { TestBaseService } from './TestBaseService';
import { AddressRequest } from './service-models/test/address/AddressRequest';
import { AddressResult } from './service-models/test/address/AddressResult';

export class TestService extends TestBaseService {
	/**
	 * テスト検索
	 * @param viewCore ビュー情報
	 * @param request リクエスト情報
	 * @param resMethod 結果処理メソッド
	 */
	public searchTest(viewCore: WprBaseViewCore, request: TestRequest, resMethod: (result: TestResult) => void): void {
		return this.doPost(viewCore, '/test/search', request, resMethod);
	}

	/**
	 * テスト検索
	 * @param viewCore ビュー情報
	 * @param request リクエスト情報
	 * @param resMethod 結果処理メソッド
	 */
	public searchAdrs(viewCore: WprBaseViewCore, request: AddressRequest, resMethod: (result: AddressResult) => void): void {
		return this.doPost(viewCore, '/test/searchAdrs', request, resMethod);
	}
}